import { connect } from 'react-redux';

import {
  getFunnelExecutionResult,
  getLabels,
  getProjectOriginalZoneId,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import LabelsChart from './LabelsChart';

const mapStateToProps = (state) => ({
  zoneId: getProjectOriginalZoneId(state),
  userZoneId: getProjectZoneId(state),
  labels: getLabels(state),
  from: getFunnelExecutionResult(state).chart.from,
  to: getFunnelExecutionResult(state).chart.to,
});

export default connect(mapStateToProps)(LabelsChart);
